export const currenciesMap: Record<number, string> = {
    840: "USD",
    978: "EUR",
    985: "PLN",
    826: "GBP",
    980: "UAH",
};